import React from 'react';
import {
	Layout,
	HamburgerMenuIcon,
} from '@phonectas/unifon-ui-kit';

import {Logo, StyledAppBar, StyledAppBarIcon} from './styles';
import UserWidget from 'containers/App/components/AppBar/user-widget';
import ActivityPlan from 'common/components/ActivityPlan';

interface AppBarProps {
	onToggleMenu: () => void;
}

/**
 * @param {function} onToggleMenu
 * @return {JSX.Element}
 * @constructor
 */
const AppBar: React.FC<AppBarProps> = ({onToggleMenu}) => {
	const isActive = false; // TODO: replace with actual condition
	return (
		<StyledAppBar nowrap fullWidth alignItems="center">
			<Layout nowrap fullWidth alignItems="center" gap="lg">
				<StyledAppBarIcon onClick={onToggleMenu}>
					<HamburgerMenuIcon />
				</StyledAppBarIcon>
				<Logo src="/assets/logo/Unifon_Logotype_negative_RGB.svg" alt="Unifon Logo" />
			</Layout>
			{
				isActive && (
					<ActivityPlan />
				)
			}
			<UserWidget />
		</StyledAppBar>
	);
}

export default React.memo(AppBar);
